import { Navigate } from "react-router-dom";
import { useStateContext } from "../contexts/ContextProvider";
import { useEffect, useState } from "react";
import api from "../api";
import LoadingBlock from "../components/LoadingBlock";

const ProtectedRoute = ({ children, rolesAllowed }) => {
  const { setUser, user, hasRole } = useStateContext();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    api
      .get("api/user/authenticated")
      .then((response) => {
        setUser(response.data.data);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);
  
  if (isLoading && !user) return <LoadingBlock />
  if (!hasRole(rolesAllowed)) return <Navigate to="/unauthorized" replace />; // Bloqueia se não tiver permissão

  return children;
};

export default ProtectedRoute;
